require("core-js/modules/esnext.global-this.js");

!function (e, r) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = r(require("react"), require("prop-types"), require("@leafygreen-ui/emotion")) : "function" == typeof define && define.amd ? define(["react", "prop-types", "@leafygreen-ui/emotion"], r) : ((e = "undefined" != typeof globalThis ? globalThis : e || self).Copy = e.Copy || {}, e.Copy.js = r(e.React, e.PropTypes, e["@leafygreen-ui/emotion"]));
}(this, function (e, r, t) {
  "use strict";

  function l(e) {
    return e && "object" == typeof e && "default" in e ? e : {
      default: e
    };
  }

  function a(e) {
    if (e && e.__esModule) return e;
    var r = Object.create(null);
    return e && Object.keys(e).forEach(function (t) {
      if ("default" !== t) {
        var l = Object.getOwnPropertyDescriptor(e, t);
        Object.defineProperty(r, t, l.get ? l : {
          enumerable: !0,
          get: function get() {
            return e[t];
          }
        });
      }
    }), r.default = e, Object.freeze(r);
  }

  var n = a(e),
      i = l(r);

  function o(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }

  function u() {
    return u = Object.assign || function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = arguments[r];

        for (var l in t) {
          Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
        }
      }

      return e;
    }, u.apply(this, arguments);
  }

  function f(e, r) {
    if (null == e) return {};

    var t,
        l,
        a = function (e, r) {
      if (null == e) return {};
      var t,
          l,
          a = {},
          n = Object.keys(e);

      for (l = 0; l < n.length; l++) {
        t = n[l], r.indexOf(t) >= 0 || (a[t] = e[t]);
      }

      return a;
    }(e, r);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);

      for (l = 0; l < n.length; l++) {
        t = n[l], r.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (a[t] = e[t]);
      }
    }

    return a;
  }

  function c(e, r) {
    return r || (r = e.slice(0)), Object.freeze(Object.defineProperties(e, {
      raw: {
        value: Object.freeze(r)
      }
    }));
  }

  var s,
      p,
      b = {
    small: 14,
    default: 16,
    large: 20,
    xlarge: 24
  };

  var d = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"],
      y = function y(e) {
    var r,
        l = e.className,
        a = e.size,
        i = void 0 === a ? 16 : a,
        y = e.title,
        g = e["aria-label"],
        m = e["aria-labelledby"],
        C = e.fill,
        O = e.role,
        v = void 0 === O ? "img" : O,
        j = f(e, d),
        h = t.css(s || (s = c(["\n    color: ", ";\n  "])), C),
        H = t.css(p || (p = c(["\n    flex-shrink: 0;\n  "]))),
        V = function (e, r, t) {
      var l,
          a,
          n = t["aria-label"],
          i = t["aria-labelledby"],
          u = t.title;

      switch (e) {
        case "img":
          return n || i || u ? (o(l = {}, "aria-labelledby", i), o(l, "aria-label", n), o(l, "title", u), l) : {
            "aria-label": (a = r, "".concat(a.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon"))
          };

        case "presentation":
          return {
            "aria-hidden": !0,
            alt: ""
          };
      }
    }(v, "Copy", (o(r = {
      title: y
    }, "aria-label", g), o(r, "aria-labelledby", m), r));

    return n.createElement("svg", u({
      className: t.cx(o({}, h, null != C), H, l),
      height: "number" == typeof i ? i : b[i],
      width: "number" == typeof i ? i : b[i],
      role: v
    }, V, j, {
      viewBox: "0 0 16 16"
    }), n.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1 5.71428V10.2857C1 11.2325 1.76751 12 2.71429 12H5.75V7.10957C5.75 6.54414 5.97724 6.00244 6.38065 5.60623L8.67403 3.35381C8.77447 3.25516 8.88376 3.16757 9 3.09182V2.71429C9 1.76751 8.23249 1 7.28571 1H5.8V4.42857C5.8 5.13865 5.22437 5.71428 4.51429 5.71428H1ZM9 4.78571L7.25654 6.49804C7.24689 6.50752 7.23749 6.5172 7.22834 6.52708C7.22208 6.53383 7.21594 6.54068 7.20991 6.54762C7.07504 6.70295 7 6.90234 7 7.10957V7.79762H9H10.0095C10.4829 7.79762 10.8667 7.41386 10.8667 6.94047V4H10.1505C9.92587 4 9.7102 4.0882 9.54992 4.24562L9 4.78571ZM4.86667 1H4.15053C3.92587 1 3.7102 1.0882 3.54992 1.24562L1.25654 3.49804C1.09244 3.65921 1 3.87957 1 4.10957V4.79762H4.00952C4.48291 4.79762 4.86667 4.41386 4.86667 3.94047V1ZM7 12V8.71428H9H10.5143C11.2244 8.71428 11.8 8.13865 11.8 7.42857V4H13.2857C14.2325 4 15 4.76751 15 5.71429V13.2857C15 14.2325 14.2325 15 13.2857 15H8.71429C7.76751 15 7 14.2325 7 13.2857V12Z",
      fill: "currentColor"
    }));
  };

  return y.displayName = "Copy", y.isGlyph = !0, y.propTypes = {
    fill: i.default.string,
    size: i.default.oneOfType([i.default.number, i.default.string]),
    className: i.default.string
  }, y;
});